(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-blend-guide]').forEach((guide) => {
      if (guide.dataset.guideReady) return;
      const choices = guide.querySelector('[data-guide-choices]');
      const buttons = [...guide.querySelectorAll('[data-guide-choice]')];
      const results = [...guide.querySelectorAll('[data-guide-result]')];
      if (!choices || !buttons.length || !results.length) return;
      const select = (value) => {
        if (!results.some((result) => result.dataset.guideResult === value)) return;
        buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.guideChoice === value)));
        results.forEach((result) => { result.hidden = result.dataset.guideResult !== value; });
      };
      buttons.forEach((button) => button.addEventListener('click', () => select(button.dataset.guideChoice)));
      select('amend');
      choices.hidden = false;
      guide.dataset.guideReady = 'true';
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
